import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
const EMPTY_ACCOUNT = { status: 'disconnected' };
export const useEvmStore = create()(persist((set) => ({
    wagmiAccount: EMPTY_ACCOUNT,
    connections: [],
    allConnectors: [],
    selectedAddress: undefined,
    ready: false,
    setActiveAddress: (address) => set({ selectedAddress: address }),
    _setWagmiAccount: (snapshot) => set({ wagmiAccount: snapshot }),
    _setConnections: (connections) => set({ connections }),
    _setConnectors: (connectors) => set({ allConnectors: connectors, ready: connectors.length > 0 }),
}), {
    name: 'ls-evm-store',
    storage: createJSONStorage(() => localStorage),
    partialize: (state) => ({ selectedAddress: state.selectedAddress }),
}));
export const snapshotFromAccount = (account) => ({
    address: account.address,
    addresses: account.addresses,
    connectorId: account.connector?.id,
    connectorName: account.connector?.name,
    chainId: account.chainId,
    status: account.status,
});
